import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PolicyLite } from '@lockton-apps/shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class Policies2Service {
  model = 'policy';

  constructor(
    @Inject('BASE_API_URL_V2') private baseUrlV2: string,
    private http: HttpClient
  ) {}

  private get url(): string {
    return `${this.baseUrlV2}/${this.model}`;
  }

  listLite(): Observable<PolicyLite[]> {
    return this.http.get<PolicyLite[]>(this.url);
  }
}
